/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type WidgetMenu_reports = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetMenu_reports",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CopyWidgetsDialog_reports",
      "args": null
    }
  ],
  "type": "ReportConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/__generated__/WidgetMenu_reports.graphql.js